import { BasicPage } from "../../components/base/BasicPage";

export default function ProfilePage2() {
  return <BasicPage title="Profile Page2" icon="" />;
}
